import HeaderAsideLayout from '@/layouts/HeaderAsideLayout';
const list = [
  {
    path: '/comments',
    component: HeaderAsideLayout,
    children: [
      { path: '/comments', component: () => import('@/pages/comments/index.vue') },
    ],
  },
]
export default list